module.exports = __webpack_public_path__ + "static/bytovka5-4d55a71adacb55c630ffec329a981016.jpeg";